import React from "react";
import "../Styles/Success/success.scss";

const Profile = () => {
  return (
    <>
      <div className="success">
        <h3>Coming Soon</h3>
      </div>
    </>
  );
};

export default Profile;
